/**
 * this component represents the overview for all Bookings
 */
import React, { useState, useEffect } from 'react';
import { getPools } from '../../../utils/api';
import BookingView from './BookingView'
import CreateBooking from './CreateBooking';
import SearchBar from '../../SeachBar';
import BookingEditView from './BookingEditView';

const BookingUnit = () => {
    const [bookings, setBookings] = useState([]); // State to store bookings
    const [selectedBooking, setSelectedBooking] = useState(null); // State to store selected booking
    const [isCreatingBooking, setIsCreatingBooking] = useState(false); // State to toggle CreateBookingView
    const [isEditMode, setIsEditMode] = useState(false);

    //TODO: Bookings fetchen, using pools as placeholder
    useEffect(() => {
        fetchPools();
    }, []);

    const fetchPools = async () => {
        try {
            const response = await getPools();
            setBookings(response.data || []);
        } catch (err) {
            console.error('Error fetching pools:', err);
        }
    };

    const handleBookingClick = (booking) => {
        setSelectedBooking(booking); // Set the selected pool
    };

    return (
        <div className="pool-list">
            <h1 className="title">Model Booking</h1>
            {isEditMode ? (
                <BookingEditView selectedBooking={selectedBooking} setSelectedBooking={setSelectedBooking} bookings={bookings} setIsEditMode={setIsEditMode}/>
            ) : selectedBooking ?
                (<BookingView selectedBooking={selectedBooking} setSelectedBooking={setSelectedBooking} bookings={bookings} setIsEditMode={setIsEditMode}/>

                ) : (
                    <>
                        <SearchBar optionalInfos={
                            [<span key={6}>Active Bookings: 6</span>]} />
                        <div style={{ textAlign: 'left' }}>
                            <button className="button" onClick={() => setIsCreatingBooking(true)}>New Booking</button>
                        </div>
                        <div className="table">
                            <div className="table-header">
                                <span className="header-cell">Booking Name</span>
                                <span className="header-cell">placeholder</span>
                                <span className="header-cell">placeholder</span>
                            </div>
                            {bookings.map((booking, index) => (
                                <div
                                    key={booking + index}
                                    className="table-row"
                                    onClick={() => { handleBookingClick(booking) }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span className="table-cell">{booking.pool_id} Booking</span>
                                    <span className="table-cell">{booking.model_count}</span>
                                    <span className="table-cell">placeholder</span>
                                </div>
                            ))}
                        </div>
                    </>
                )}
        </div>
    );
};

export default BookingUnit;
